import ArditBido from "../Assets/Images/KeshilliArkivave/ArditBido.jpg";

import EndritMusaj from "../Assets/Images/KeshilliArkivave/Endrit Musaj.jpg";
import LorencAgalliu from "../Assets/Images/KeshilliArkivave/LorencAgalliu.jpeg";
import dpa from "../Assets/Images/KeshilliArkivave/Arben Dervishllari.png";
import ArmandoBoçe from "../Assets/Images/KeshilliArkivave/Armando Boce.jpg";
import KristinaJorgaqi from "../Assets/Images/KeshilliArkivave/Kristina Jorgaqi.jpg";
import MarinelaNdria from "../Assets/Images/KeshilliArkivave/Marinela Ndria.jpg";
import ArmantVogli from "../Assets/Images/KeshilliArkivave/Armant Vogli.png";
import ElsaSaka from "../Assets/Images/KeshilliArkivave/Elsa Saka.jpeg";
import EugenNako from "../Assets/Images/KeshilliArkivave/Eugen Nako.png";
import White from "../Assets/Images/White.png";
export const drejtoriaData = [
  {
    title: "Historiku",
    path: "/drejtoria/historiku",
    leftContent: (
      <>
        <p>
          Fillimet e veprimtarisë arkivore në Shqipëri datojnë që nga
          antikiteti. Historia dëshmon se në bibliotekat që ekzistonin në
          shtetet ilire, në pricipatat feudale shqiptare, në shtetin e
          Skënderbeut, në shoqëritë patriotike e kulturore, në institucionet
          fetare, në firmat tregtare, në esnafët, në familje dhe individë të
          veçantë, krahas librave ruheshin edhe dokumente.
        </p>
        <p>
          Zhvillimet politike e shoqërore në hapsirat shqiptare dhe më gjerë, u
          shoqëruan me dukuri të reja edhe për arkivat dhe dokumentet. Në
          përgjithësi arkivat konceptoheshin si bibliotekë-arkiva dhe kujdesi
          për dokumentet vinte në rritje.
        </p>
        <p>
          Shpallja e Pavarësisë, më 1912 dhe krijimi i Shtetit të Pavarur
          Shqiptar, krijoi kushte edhe për organizimin e punës për kujdes më të
          madh për dokumentet. Për herë të parë në histori vlerësimi i
          dokumenteve dhe administrimi e ruajtja e tyre gjen pasqyrim në aktin
          më të lartë normativ të shtetit. Në kanunin e Përkohshëm të Qeverisë
          së Vlorës, u sanksionua veprimtaria e njësive të posaçme strukturore
          në organet e administratës shtetërore, për punën me dokumentet.
        </p>
        <p>
          Në të gjitha aktet ligjore e nënligjore, në vazhdimësi, për krijimin
          dhe funksionimin e organeve të administratës shtetërore përfshiheshin
          detyra edhe për administrimin dhe për ruajtjen e dokumenteve.
        </p>
        <p>
          Krahas këtyre masave nuk reshtën dhe përpjekjet për krijim e një
          arkivi Qendror, ku do të përqëndroheshin dokumentet më të rëndësishëm
          për historinë kombëtare.Dokumenti i parë që ruhet në Arkivin Qendror
          Shtetëror, që bën fjalë për përpjekjet drejt krijimit të një Arkivi
          Qendror, është vendimi i datës 02.01.1932 i Këshillit të Naltë të
          Shtetit, për shqyrtimin e projekt-rregullores, për regjistrimin e
          ngjarjeve me rëndësi. Në këtë projekt-rregullore, parashikohej edhe
          krijimi i Arkivit të Përgjithshëm të Shtetit.
        </p>
        <p>
          Moment i rëndësishëm për historinë e arkivave shqiptare është
          projekt-ligji i vitit 1932 “Per krijimin e Arkivës së Përgjithshme të
          Shtetit dhe të Kronikës Historike”, në nenin 1 të të cilit
          përcaktohej: “Krijohet në kryeqytet një Arkivë e Përgjithshme e
          Shtetit , për me përmblesh e ruajtë gjithë dokumentet zyrtare”.
          Megjithëse projekt-ligji nuk u zbatua, ai i dha një nxitje zhvillimit
          të veprimtarisë arkivore.
        </p>
        <p>
          Lufta e Dytë Botërore, ngadalësoi nismat e marra nga organet
          shtetërore për arkivat dhe ata deri në përfundim të saj mbetëtn në
          nivelin e sekretari-arkivave, si njësi strukturore të institucioneve,
          që ndiqnin dhe përgjigjeshin vetëm për administrimin e dokumenteve të
          tyre. Megjithatë në sajë të veprimtarisë së tyre, u bë e mundur që të
          ruhen e të trashëgohen sasi të vlerësueshme dokumentesh me shtrirje
          pothuajse gjithëpërfshirëse subjektesh, kohore, hapsinore dhe në
          përmbajtje.
        </p>
        <p>
          Përpjekjet për krijim e një arkivi qendror vazhduan edhe pas Luftës së
          Dytë Botërore. Në vitin 1947, pranë Institutit të Studimeve u krijua
          “Arkivi Dokumentar i Institutit”. Ai grumbulloi një sasi të
          konsiderueshme dokumentesh historikë që ruheshin në organet shtetërorë
          apo individë të veçantë, duke marrë kështu dhe atributet e një Arkivi
          Qendror, por jo me të gjitha karakteristikat e një organi të tillë.
        </p>
        <p>
          Arkivi Qendror Shtetëror (AQSH), u krijua si organ Qendror, megjithëse
          në varësi të Institutit të Studimeve, me urdhëresën e Këshillit të
          Ministrave nr 21 datë 08.06.1949.Krijimi i tij shënon një moment
          kulmor për historinë e arkivave shqiptare.
        </p>
        <p>
          Për herë të parë, krahas arkivave të organeve shtetërore, filloi
          funksionimi i një organi të mirëfilltë arkivor me shtrirje
          gjithështetërore. Në vitin 1951, Arkivi Qendror i Shtetit kaloi në
          varësi të Ministrisë së Punëve të Brendshme, varësi të cilën e ruajti
          deri në vitin 1962, kur u krijua Drejtoria e Përgjithshme e Arkivave
          të Shtetit (sot Drejtoria e Përgjithshme e Arkivave) , në varësi të
          Këshillit të Ministrave. Krahas të qenit organ Qendror, kjo Drejtori
          kishte dhe ka edhe atributet e Arkivit Qendror Shtetëror, si arkivi më
          i rëndësishëm dhe më i pasur i rrjetit arkivor të vendit.
        </p>
      </>
    ),
    rightContent: "",
  },
  {
    title: "Këshilli i Lartë i Arkivave",
    path: "/drejtoria/kla-kpe-kdzh-kqe",
    sections: [
      {
        title: "Këshilli i Lartë i Arkivave",
        leftContent: (
          <>
            <p>
              Këshilli i Lartë i Arkivave është organ ndërinstitucional
              vendimmarrës, para të cilit Drejtoria e Përgjithshme e Arkivave
              raporton për veprimtarinë e saj. Ky organ mblidhet jo më pak se dy
              herë në vit. KLA-së ka për detyrë të miratojë strategjitë
              afatgjata, afatmesme dhe afatshkurtra të zhvillimit të shërbimit
              arkivor, që kanë të bëjnë me politikën arkivore të qeverisë
              shqiptare.
            </p>
            <p>
              KLA përbëhet nga 17 anëtarë, 9 janë përfaqësues të Drejtorisë së
              Përgjithshme të Arkivave dhe 8 të jashtëm. KLA ka në përbërjen e
              tij titullarët e instucioneve më të rëndësishme në fushën e
              trashëgimisë kulturore dhe akademike. Mbledhjet e KLA-së
              zhvillohen pranë mjediseve të Drejtorisë së Përgjithshme të
              Arkivave. Para zhvillimit të çdo mbledhjeje anëtarët e tij
              njoftohen prej sekretarit për zhvillimin e saj. Atyre u dërgohet
              rendi ditës dhe materialet përkatëse një javë para zhvillimit të
              mbledhjes. Vendimet e KLA-së janë të detyrueshme dhe zbatueshme
              për të gjithë rrjetin arkivor të Republikës së Shqipërisë.
            </p>
            <p>
              Sekretari i KLA-së zgjidhet me shumicën e votave të numrit të
              përgjithshëm të anëtarëve. Sekretar mund të zgjidhet anëtari i
              KLA-së që ka specializim në fushën e arkivave. Ai ushtron
              përgjegjësinë e kryetarit për drejtimin e mbledhjes së KLA-së në
              mungesë dhe me urdhër të tij.
            </p>
            <p>KLA miraton:</p>
            <ul>
              <li>
                paraprakisht, projektaktet ligjore e nënligjore që DPA-ja
                rekomandon për organizimin dhe funksionimin e shërbimit arkivor
                kombëtar;
              </li>
              <li>
                “Listën tip” të dokumenteve me rëndësi historike kombëtare të
                njësuar në shkallë vendi;
              </li>
              <li>
                të gjitha aktet që kanë të bëjnë me strategjinë afatmesme dhe
                afatgjatë të zhvillimit të shërbimit arkivor kombëtar;
              </li>
              <li>
                rregullat tekniko-profesionale dhe metodologjike të punës me
                dokumentet (administrative, tekniko-shkencore, në figurë, zë dhe
                në lëvizje);
              </li>
              <li>
                rregullore me natyrë unifikuese për punën me dokumentet; dh)
                raportin e analizës vjetore të DPA-së;
              </li>
              <li>raportin e analizës vjetore të DPA-së;</li>
              <li>
                standardet e kutive, të dosjeve dhe mjeteve kancelarike, që
                ndikojnë te cilësia dhe jetëgjatësia e dokumentit, të
                detyrueshme për zbatim nga të gjitha institucionet e Republikës
                së Shqipërisë;
              </li>
              <li>
                standardet e kutive e të dosjeve për ruajtje të përhershme për
                dokumentet me RHK, për arkivat e përhershëm, arkivat qendrorë në
                veprim, si dhe për institucionet që ruajnë dokumentacion
                gjithnjë pranë tyre dhe përcakton institucionet dhe tipologjinë
                e dokumenteve të institucioneve, që janë të detyruara të
                zbatojnë standardin.
              </li>
            </ul>
          </>
        ),
        rightContent: [
          {
            image: dpa,
            name: "-------",
            institution: "Drejtori i Përgjithshëm i Arkivave",
          },
          {
            image: EndritMusaj,
            name: "Endrit Musaj",
            institution: "Zv/Drejtor i Përgjithshëm i Arkivave",
          },
          {
            image: MarinelaNdria,
            name: "Marinela Ndria",
            institution: "Zv/Drejtor i Përgjithshëm i Arkivave",
          },
          {
            image: dpa,
            name: "Arben Dervishllari",
            institution:
              "Drejtori i Drejtorisë së Financës dhe Shërbimeve Mbështetëse",
          },
          {
            image: LorencAgalliu,
            name: "Lorenc Agalliu",
            institution: "Drejtori Drejtorisë së Arkivave Shtetërore Vendore",
          },
          {
            image: ArmandoBoçe,
            name: "Armando Boçe",
            institution: "Drejtor i Drejtorisë së Arkivave Qendrore",
          },
          {
            image: EugenNako,
            name: "Eugen Nako",
            institution: "DPA",
          },
          {
            image: ArmantVogli,
            name: "Armant Vogli",
            institution: "Drejtor i Drejtorisë së Punës me Dokumentet",
          },
          {
            image: ElsaSaka,
            name: "Elsa Saka",
            institution: "Drejtore e Drejtorisë së Shërbimeve Arkivore",
          },
          {
            image: White,
            name: "Gëzim Hoxha",
            institution: "Akademia e Shkencave",
          },
          {
            image: KristinaJorgaqi,
            name: "Kristina Jorgaqi",
            institution: "Akademia e Shkencave",
          },
          {
            image: White,
            name: "Mira Hoxha",
            institution: "Arkivi Historik dhe Diplomatik i MEPJ",
          },
          {
            image: White,
            name: "Gjergj Thomai",
            institution: "Arkivi Qendror Teknik i Ndërtimit",
          },

          {
            image: White,
            name: "Ilira Çaushi(Sulo)",
            institution: "Fakulteti i Historisë dhe i Filologjisë",
          },

          {
            image: White,
            name: "Rudina Shiroka",
            institution: "Arkivi i Kuvendit",
          },
          {
            image: White,
            name: "Eljan Tanini",
            institution: "Arkivi Qendror Shtetëror i Filmit",
          },
          {
            image: White,
            name: "Zeqir Zeqaj",
            institution: "Arkivi Qendror Shtetëror i Drejtësisë",
          },
        ],
      },
      {
        title:
          'Komisioni i Deklasifikimit dhe Zhvlerësimit të Informacionit të klasifikuar "Sekret Shtetëror"',
        leftContent: (
          <>
            <p>
              Komisioni i Deklasifikimit dhe Zhvlerësimit të Informacionit të
              klasifikuar Sekret Shtetëror (KDZH) në Drejtorinë e Përgjithshme
              të Arkivave(DPA) krijohet me urdhër të Drejtorit të Përgjithshëm.
            </p>
            <p>
              KDZH e DPA deklasifikon plotësisht, pjesërisht ose përjashton nga
              deklasifikimi informacione të klasifikuara "Sekret Shtetëror", që
              administrohen në Arkivat Qendrore Shtetërore, të krijuara para
              hyrjes në fuqi të Ligjit nr.8457, viti 1999 "Për informacionin e
              klasifikuar "Sekret Shtetëror".
            </p>
          </>
        ),
        rightContent: [
          {
            image: dpa,
            name: "----------",
            institution: "Drejtori i Përgjithshëm i Arkivave",
          },
          {
            image: ArmandoBoçe,
            name: "Armando Boçe",
            institution: "Drejtori i Drejtorisë së Arkivave Qendrore",
          },
          {
            image: ElsaSaka,
            name: "Elsa Saka",
            institution: "Drejtore e Drejtorisë së Shërbimeve Arkivore",
          },
          {
            image: LorencAgalliu,
            name: "Lorenc Agalliu",
            institution: "Drejtori Drejtorisë së Arkivave Shtetërore Vendore",
          },
          {
            image: dpa,
            name: "Edmond Shehi",
            institution: "Përgjegjës i Sektorit të Arkivit Qendror Shtetëror",
          },
          {
            image: dpa,
            name: "Theodhora Lena",
            institution: "Inspektore e Drejtorisë së Inspektimit",
          },
          {
            image: dpa,
            name: "Pashk Alia",
            institution: "Përgjegjës i Sektorit të ish-Arkivit Qendror të PPSH",
          },
        ],
      },
      {
        title: "Komisioni Qendror i Ekspertizës",
        leftContent: (
          <>
            <p>
              Komisioni Qendror i Ekspertizës përbëhet nga 15 anëtarë, 7 të
              brendshëm dhe 8 të jashtëm.Anëtarë të brendshëm janë përfaqësuesit
              e Drejtorisë së Përgjithshme të Arkivave, të zgjedhur nga Drejtori
              i Përgjithshëm nga radhët e nëpunësve me, së paku 10 vjet përvojë
              në shërbimin arkivor.
            </p>
            <p>
              Anëtarët e jashtëm të KQE-së përzgjidhen nga titullarët e
              institucioneve që përfaqësojnë, si më poshtë vijon:
              <ul style={{ listStyleType: "none" }}>
                <li>
                  a) një përfaqësues i ministrisë përgjegjëse për trashëgiminë
                  kulturore;
                </li>
                <li>b) një përfaqësues i Institutit të Statistikës;</li>
                <li>
                  c) një përfaqësues i Arkivit Qendror Teknik të Ndërtimit;
                </li>
                <li>
                  ç) një përfaqësues i Arkivit Qendror Shtetëror të Filmit;
                </li>
                <li>d) një përfaqësues i Arkivit Historik dhe Diplomatik;</li>
                <li>
                  dh) një përfaqësues i Arkivit Qendror Shtetëror të Drejtësisë;
                </li>
                <li>e) një përfaqësues i Arkivit të Kuvendit;</li>
                <li>
                  ë) një përfaqësues i Arkivave Qendrorë në veprim, zgjedhur me
                  votim të fshehtë, nga mbledhja e drejtorëve të tyre.
                </li>
              </ul>
            </p>
            <p>
              Kryetar i KQE-së është zëvendësdrejtori i përgjithshëm i Arkivave,
              i emëruar nga drejtori i përgjithshëm i Arkivave.Kryetari miraton
              rendin e ditës së mbledhjes së KQE-së , drejton mbledhjen dhe
              nënshkruan vendimet e saj.
            </p>
            <p>
              Sekretari i KQE-së zgjidhet me shumicën e votave të numrit të
              përgjithshëm të anëtarëve. Sekretar mund të zgjidhet anëtari i
              KQE-së që ka specializim në fushën e arkivave.Ai ushtron
              përgjegjësinë e kryetarit për drejtimin e mbledhjes së KQE-së në
              mungesë dhe me urdhër të tij.
            </p>
            <p>
              KQE-ja kryen këto detyra:
              <ul style={{ listStyleType: "none" }}>
                <li>
                  a) Përgatit "Listën tip" të dokumenteve me rëndësi historike
                  kombëtare(më tej "RHK");
                </li>
                <li>
                  b) miraton listat e dosjeve të veçanta për asgjësim, sipas
                  vendimeve të institucioneve të përcaktuara në ligj, për
                  dokumentet që kanë humbur vlerën e ruajtjes së mëtejshme;
                </li>
                <li>
                  c) miraton listat e dokumenteve të veçuara për asgjësim nga
                  Arkivi Qendror Shtetëror, arkivat shtetërorë vendorë dhe
                  arkivat e sistemit në rast të risistemimit të fondeve.Në këtë
                  rast, vendimi merret nga Komisioni i Ekspertizës së Drejtorisë
                  së Përgjithshme të Arkivave, pas relacionit të drejtorisë
                  përgjegjëse për përpunimin.
                </li>
                <li>
                  ç) vendimet e KQE-së u dërgohen institucioneve përkatëse dhe
                  zbatimi i tyre ndiqet nga DPA.
                </li>
                <li></li>
                <li></li>
              </ul>
            </p>
          </>
        ),
        rightContent: [
          {
            image: EndritMusaj,
            name: "Endrit Musaj (Kryetar)",
            institution: "Zv/Drejtor i Përgjithshëm në DPA",
          },

          {
            image: LorencAgalliu,
            name: "Lorenc Agalliu",
            institution: "Drejtor i Drejtorisë së Arkivave Shtetërore Vendore",
          },
          {
            image: dpa,
            name: "Eralda Cara",
            institution: "DPA",
          },
          {
            image: dpa,
            name: "Theodhora Lena (Sekretare)",
            institution: "DPA",
          },
          {
            image: dpa,
            name: "Alketa Rëmbeci",
            institution: "DPA",
          },
          {
            image: dpa,
            name: "Nurjeta Kulla",
            institution: "DPA",
          },
          {
            image: dpa,
            name: "Adriana Shehu",
            institution: "DPA",
          },
          {
            image: White,
            name: "Esjona Metushi",
            institution:
              "Specialist në Arkivin Historik dhe Diplomatik në Ministrinë për Europën dhe Punët e Jashtme",
          },
          {
            image: White,
            name: "Zeqir Zeqaj",
            institution: "Drejtor i Arkivit Qendror Shtetëror i Drejtësisë",
          },
          {
            image: White,
            name: "Rudina Shiroka",
            institution: "Përgjegjëse e Sektorit të Arkivës Parlamentare",
          },

          {
            image: White,
            name: "Luljeta Furtuzi",
            institution:
              "Përgjegjëse e Fondit Arkivor në Arkivin Qendror Tektik të Ndërtimit",
          },

          {
            image: White,
            name: "Migena Alushani",
            institution: "Arkiviste në Institutin e Statistikave",
          },
          {
            image: White,
            name: "Ana Nikollaj",
            institution: "Arkiviste në Arkivin Qendror Shtetëror të Filmit",
          },
          {
            image: White,
            name: "Anila Nuredini",
            institution: "Specialiste Arkivi në Ministrinë e  Kulturës",
          },
        ],
      },
      {
        title: "Komisioni Përhershëm i Ekspertëve",
        leftContent: (
          <>
            <p>
              KPE-ja bën vlerësimin e dokumenteve me rëndësi historike
              kombëtare, qe janë ne shitje prej subjekteve private, dhe miraton
              pranimin e dokumenteve nga qytetarët.
            </p>
            <p>
              KPE-ja miraton, paraprakisht:
              <ul style={{ listStyleType: "none" }}>
                <li>
                  a) "Listën tip", me afatet e ruajtjes se dokumenteve
                  administrative RHK, qe i paraqitet nga Komisioni Qendror i
                  Ekspertizës;
                </li>
                <li>
                  b) shperdarjen në vendruajtje te fondeve te dokumenteve qe
                  administrohen nga DPA;
                </li>
                <li>
                  c) matricën e njësuar te pershkrimit të dokumentit RHK, ge
                  subjekti joshtetëror privat nxjerr në shitje;
                </li>
                <li>ç) pranimin e dokumenteve te dhuruara;</li>
                <li>
                  d) vleresimin e kushteve te parablerjes se ketyre
                  dokumenteve.KPE-ja jep mendimin perkates për dhënien ose jo te
                  lejes se tregtimit te lire te dokumenteve RHK, gë subjektet
                  joshtetërore private duan tẻ shesin. Mendimi i percillet
                  DPA-së, për të ushtruar të drejtën e vendimmarrjes; dh)
                  dërgimin dhe/ose moslejimin e nxjerrjes jashte vendit te
                  dokumenteve RHK ne pronësi të shtetit dhe/ose të subjekteve
                  joshtetërore private, ne rast se kêto dokumente perbëjne vlera
                  unikale, në kuadër te trashëgimisê arkivore tê vendit, tê
                  cilat ia percjell drejtorit te Përgjithshëm të Arkivave për
                  hartimin e propozimit drejtuar Kryeministrit, për miratim
                  perfundimtar nga Këshilli i Ministrave, sipas percaktimit të
                  nenit 83, të ligjit nr.9154, dat 6.11.2003, "Për arkivat";
                </li>
                <li>
                  e) kushtet e tregtimit të dokumenteve RHK, ne rast te
                  ndryshimit të pronarit privat. Këto kushte KPE-ja ia propozon
                  DPA-së, për ushtrimin e së drejtës se vendimmarrjes. Kjo e
                  fundit mund të kufizoje shitjen e kêtyre dokumenteve deri ne
                  30 dite, nga data e marrjes se njoftimit prej pronarit. Kur
                  KPE-ja nuk arrin te marrë vendim, duke u mbështetur vetëm në
                  përshkrimet arkivistike, për të propozuar ndalimin dhe/ose te
                  kushtëzojë shitjen e lirë të dokumenteve RHK në pronesi të
                  subjekteve joshtetërore private, ajo ka te drejte të njihet me
                  vetë dokumentin, me perjashtim të rasteve te kufizuara me
                  ligj. Pronari joshtetëror privat i dokumenteve RHK ka të
                  drejten e ankimit ne giykate kundër vendimit te Drejtorise së
                  Përgjithshme te Arkivave, sipas Kodit të Procedurave
                  Administrative;
                </li>
                <li>
                  ë) rregullat per paraqitjen e dokumenteve arkivore në mjediset
                  ndërkombëtare;
                </li>
                <li>
                  f) listën e pronarëve të arkivave private, tê cilët u dhurojnë
                  arkivave shtetërore dokumente të shpallura RHK.
                </li>
              </ul>
            </p>
          </>
        ),
        rightContent: [
          {
            image: EndritMusaj,
            name: "Endrit Musaj",
            institution: "Zv/Drejtor i Përgjithshëm në DPA",
          },

          {
            image: dpa,
            name: "Edmond Shehi",
            institution: "Përgjegjës i Sektorit të Arkivit Qendror Shtetëror",
          },
          {
            image: White,
            name: "Prof.Dr. Sabri Laçi",
            institution: "Pedagog në Universitetin e Tiranës",
          },
          {
            image: White,
            name: "Prof.Dr. Eva Hyskaj",
            institution: "Pedagoge në Universitetin e Tiranës",
          },
          {
            image: White,
            name: "Akad. Beqir Meta",
            institution:
              "Drejtor i Institutit të Historisë, Akademia e Shkencave",
          },
          {
            image: White,
            name: "Akad. Neki Frashëri",
            institution: "Anëtar i Akademisë së Shkencave",
          },
          {
            image: White,
            name: "Pirro Misha",
            institution: "Drejtor i Bibliotekës Kombëtare",
          },
          {
            image: White,
            name: "Rudina Zoto",
            institution:
              "Përfaqësuese e Ministrisë së Ekonomisë, Kulturës dhe Inovacionit ",
          },
        ],
      },
    ],
  },
  {
    title: "Organizimi i Rrjetit Arkivor",
    path: "/drejtoria/organizimi-i-rrjetit-arkivor",
    leftContent: (
      <p>
        Drejtoria e Përgjithshme e Arkivave është drejtuesja rrjetit arkivor
        kombëtar në Republikën e Shqipërisë. Arkivi Qendror Shtetëror dhe
        Arkivat Shtetërorë Vendorë janë në varësi administrative dhe
        profesionale të DPA-së. Ndërkaq, arkivat e tjera janë në varësi
        metodologjike e profesionale të Drejtorisë së Përgjithshme të Arkivave.
        Këto arkiva janë Arkivat e Sistemit dhe Arkivat e Tipologjisë, si arkiva
        të përhershme dhe sekretari-arkivat e të gjitha autoriteteve publike e
        institucioneve shtetërore në Shqipëri. Ky rrjet, ruan, përpunon,
        administron dhe shërben Fondin Arkivor Kombëtar të Republikës së
        Shqipërisë.
      </p>
    ),
    rightContent: [
      {
        title: "Arkiva të Sistemit",
        subtitle:
          "(arkivat shtetërore të sistemit që funksionojnë në mënyrë të përhershme pranë institucioneve qendrore fondkrijuese)",
        list: [
          {
            name: "Arkivi Historik dhe Diplomatik",
            url: "http://www.punetejashtme.gov.al/",
          },
          {
            name: "Arkivi i Forcave të Armatosura",
            url: "http://www.mod.gov.al/index.php/ministria/strukturat-vartese/117-arkivi-i-fa",
          },

          {
            name: "Arkivi i Punëve të Brendshme",
            url: "http://www.punetebrendshme.gov.al/",
          },
          // {
          //   name: "Arkivi i Kuvendit të Shqipërisë",
          //   url: "http://www.parlament.al/",
          // },
          // {
          //   name: "Arkivi i Presidentit të Republikës",
          //   url: "http://president.al/",
          // },
          // {
          //   name: "Arkivi i Institutit të Sigurimeve Shoqërore",
          //   url: "http://www.issh.gov.al/",
          // },
          // {
          //   name: " Autoriteti për Informimin mbi Dokumentat e Ish-Sigurimit të Shtetit",
          //   url: "http://autoritetidosjeve.gov.al/",
          // },
        ],
      },
      {
        title: "Arkiva Privatë",
        subtitle:
          "(arkiva të licensuara për të ushtruar veprimtarinë e arkivit privat)",
        list: [
          "Albanian Archives shpk",

          "Vendim Nr.7, datë 29.07.2020 i Këshillit të Lartë të Arkivave",
          "Licencë Aktive",
          "Tirana Archive",
          "Vendimi Nr.35 datë 24.1.2018 i Këshillit të Ministrave",
        ],
      },
      {
        title: "Arkiva të së Njëjtës Tipologji",
        subtitle: "",
        list: [
          {
            name: "Arkivi Qendror Teknik i Ndërtimit",
            url: "http://www.aqtn.gov.al/",
          },
          {
            name: "Arkivi Qendror Shtetëror i Filmit",
            url: "http://www.aqshf.gov.al/",
          },
          {
            name: "Arkivi Qendror Shtetëror i Drejtësisë",
            url: "https://ashsgj.gov.al/",
          },
        ],
      },
    ],
  },
  {
    title: "Struktura",
    path: "/drejtoria/struktura",
    content: [
      {
        name: "Drejtori i Përgjithshëm i Arkivave",
        image: ArditBido,
        path: "",
        sektoret: [
          {
            name: "Drejtori i Përgjithshëm i Arkivave",
            path: "#",
          },
          {
            name: "Funksionet e Drejtorit të Përgjithshëm",
            path: "/struktura/funksionet-e-drejtorit-te-pergjithshem",
          },
          {
            name: "Drejtorët në vite",
            path: "/struktura/drejtoret-ne-vite",
          },
          {
            name: "Zëvendësdrejtori i Përgjithshëm",
            path: "/struktura/zevendesdrejtori-i-pergjithshem",
          },
          {
            name: "Sektori i Menaxhimit dhe Trajnimeve",
            path: "/struktura/sektori-menaxhimit-dhe-trajnimeve",
          },
          {
            name: "Sektori i Auditimit të Brendshëm",
            path: "/struktura/sektori-auditimit-te-brendshem",
          },
        ],
      },

      {
        name: "Drejtoria e Inspektimit",
        path: "/struktura/drejtoria-e-inspektimit",
        sektoret: [
          {
            name: "Drejtori i Inspektimit",
            path: "#",
          },
          {
            name: "Sektori i Inspektimit Qendror",
            path: "/struktura/drejtoria-e-inspektimit/sektori-i-inspektimit-qendror",
          },
          {
            name: "Sektori i Inspektimit Veri",
            path: "/struktura/drejtoria-e-inspektimit/sektori-i-inspektimit-veri",
          },
          {
            name: "Sektori i Inspektimit Jug",
            path: "/struktura/drejtoria-e-inspektimit/sektori-i-inspektimit-jug",
          },
          {
            name: "Sektori Rregullator",
            path: "/struktura/drejtoria-e-inspektimit/sektori-i-rregullator",
          },
        ],
      },

      {
        name: "Drejtoria e Promovimit",
        path: "/struktura/drejtoria-e-promovimit",
        sektoret: [
          {
            name: "Drejtori i Promovimit",
            path: "#",
          },
          {
            name: "Sektori i Mediave dhe Audiovizual",
            path: "/struktura/drejtoria-e-promovimit/sektori-i-mediave-dhe-audiovizual",
          },
          {
            name: "Sektori i Eventeve dhe Ekspozitave",
            path: "/struktura/drejtoria-e-promovimit/sektori-i-eventeve-dhe-ekspozitave",
          },
          {
            name: "Sektori i Programeve Edukuese e Shkencore",
            path: "/struktura/drejtoria-e-promovimit/sektori-i-programeve-edukuese-e-shkencore",
          },
          {
            name: "Sektori i Projekteve dhe Marrëdhënieve me Jashtë",
            path: "/struktura/drejtoria-e-promovimit/sektori-i-projekteve-dhe-marredhenieve-me-jashte",
          },
        ],
      },

      {
        name: "Drejtoria e Arkivave Shtetërore Vendore",
        path: "/struktura/drejtoria-e-arkivave-shteterore-vendore",
        sektoret: [
          {
            name: "Drejtori i Arkivave Shtetërore Vendore",
            path: "/struktura/drejtoria-e-arkivave-shteterore-vendore/drejtori-i-arkivave-shteterore-vendore",
          },
          {
            name: "Sektori i Arkivave Shtetërore Vendore Tiranë dhe Durrës",
            path: "/struktura/drejtoria-e-arkivave-shteterore-vendore/sektori-i-ashv-tirane-dhe-durres",
          },
          {
            name: "Sektori i Arkivave Shtetërore Vendore Elbasan, Korçë dhe Berat",
            path: "/struktura/drejtoria-e-arkivave-shteterore-vendore/sektori-i-ashv-elbasan-korce-dhe-berat",
          },
          {
            name: "Sektori i Arkivave Shtetërore Vendore Fier, Vlorë dhe Gjirokastër",
            path: "/struktura/drejtoria-e-arkivave-shteterore-vendore/sektori-i-ashv-fier-vlore-dhe-gjirokaster",
          },
          {
            name: "Sektori i Arkivave Shtetërore Vendore Shkodër, Lezhë, Dibër dhe Kukës",
            path: "/struktura/drejtoria-e-arkivave-shteterore-vendore/sektori-i-ashv-shkoder-lezhe-diber-dhe-kukes",
          },
        ],
      },

      {
        name: "Drejtoria e Shërbimeve Arkivore",
        path: "/struktura/drejtoria-e-sherbimeve-arkivore",
        sektoret: [
          {
            name: "Drejtori i Shërbimeve Arkivore",
            path: "/struktura/drejtoria-e-sherbimeve-arkivore/drejtori-i-sherbimeve-arkivore",
          },
          {
            name: "Sektori i Shërbimit ndaj Studiuesve",
            path: "/struktura/drejtoria-e-sherbimeve-arkivore/sektori-i-sherbimit-ndaj-studiuesve",
          },
          {
            name: "Sektori i Shërbimit ndaj Qytetarëve",
            path: "/struktura/drejtoria-e-sherbimeve-arkivore/sektori-i-sherbimit-ndaj-qytetareve",
          },
          {
            name: "Sektori i Testimeve, Libërlidhjes dhe Mikrofilmimit",
            path: "/struktura/drejtoria-e-sherbimeve-arkivore/sektori-i-testimeve-liberlidhjes-dhe-mikrofilmimit",
          },
          {
            name: "Sektori i Restaurimit",
            path: "/struktura/drejtoria-e-sherbimeve-arkivore/sektori-i-restaurimit",
          },
        ],
      },
      {
        name: "Drejtoria e Arkivave Qendrore",
        path: "/struktura/drejtoria-e-arkivave-qendrore",
        sektoret: [
          {
            name: "Drejtori i Arkivave Qendrore",
            path: "/struktura/drejtoria-e-arkivave-qendrore/drejtori-i-arkivave-qendrore",
          },
          {
            name: "Sektori i Arkivit Qendror Shtetëror",
            path: "/struktura/drejtoria-e-arkivave-qendrore/sektori-i-arkivit-qendror-shteteror",
          },
          {
            name: "Sektori i ish-Arkivit Qendror të Partisë",
            path: "/struktura/drejtoria-e-arkivave-qendrore/sektori-i-ish-arkivit-qendror-te-partise",
          },
          {
            name: "Sektori i Arkivit të Forcave të Armatosura",
            path: "/struktura/drejtoria-e-arkivave-qendrore/sektori-i-arkivit-te-forcave-te-armatosura",
          },
          {
            name: "Sektori i Arkivit të Punëve të Brendshme",
            path: "/struktura/drejtoria-e-arkivave-qendrore/sektori-i-arkivit-te-puneve-te-brendshme",
          },
        ],
      },

      {
        name: "Drejtoria e Punës me Dokumentet",
        path: "/struktura/drejtoria-e-punes-me-dokumentet",
        sektoret: [
          {
            name: "Drejtori i Punës me Dokumentet",
            path: "#",
          },
          {
            name: "Sektori i Regjistrimit dhe Evidencimit",
            path: "/struktura/drejtoria-e-punes-me-dokumentet/sektori-i-regjistrimit-dhe-evidencimit",
          },
          {
            name: "Sektori i Digjitalizimit",
            path: "/struktura/drejtoria-e-punes-me-dokumentet/sektori-i-digjitalizimit",
          },
          {
            name: "Sektori i Gjuhëve të Rralla",
            path: "/struktura/drejtoria-e-punes-me-dokumentet/sektori-i-gjuheve-te-rralla",
          },
          {
            name: "Sektori i Përshkrimit Arkivor",
            path: "/struktura/drejtoria-e-punes-me-dokumentet/sektori-i-pershkrimit-arkivor",
          },
        ],
      },

      {
        name: "Drejtoria e Financës dhe Shërbimeve Mbështetëse",
        path: "/struktura/drejtoria-e-finances-dhe-sherbimeve-mbeshtetese",
        sektoret: [
          {
            name: "Drejtori i Financës dhe Shërbimeve Mbështetëse",
            path: "/struktura/drejtoria-e-finances-dhe-sherbimeve-mbeshtetese/drejtori-i-finances-dhe-sherbimeve-mbeshtetese",
          },
          {
            name: "Sektori i Financës dhe Buxhetit",
            path: "/struktura/drejtoria-e-finances-dhe-sherbimeve-mbeshtetese/sektori-i-finances-dhe-buxhetit",
          },
          {
            name: "Sektori i Prokurimeve, Juridik dhe Investimeve",
            path: "/struktura/drejtoria-e-finances-dhe-sherbimeve-mbeshtetese/sektori-i-prokurimeve-juridik-dhe-investimeve",
          },
          {
            name: "Sektori i Burimeve Njerëzore dhe Sekretari-Arkivit",
            path: "/struktura/drejtoria-e-finances-dhe-sherbimeve-mbeshtetese/sektori-i-burimeve-njerezore-dhe-sekretari-arkivit",
          },
          {
            name: "Sektori i Shërbimeve të Brendshme",
            path: "/struktura/drejtoria-e-finances-dhe-sherbimeve-mbeshtetese/sektori-i-sherbimeve-te-brendshme",
          },
        ],
      },
    ],
  },
];
